'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = 'M544 121.2c0 46-25.9 86-64 106.1l0 284.7-80 0 0-168.2-119.7 88.2 71.7 0 0 80-288 0 0-328c0-30.9-25.1-56-56-56l-8 0 0-16 8 0c39.8 0 72 32.2 72 72l0 136.3c35.3-93.2 125.1-159.6 230.5-160.3-4.2-12.2-6.5-25.2-6.5-38.8l0-160.9 12.7 9.2 85.9 62.5 42.7 0 85.9-62.5 12.7-9.2 0 160.9zM312 176C183.9 176 80 279.9 80 408l0 88 256 0 0-48-88 0 0-48c0-26.5-21.5-48-48-48l-16 0 0-16 16 0c35.3 0 64 28.7 64 64l0 24.2 139.3-102.6 12.7-9.4 0 183.8 48 0 0-261.7c-12.5 4.4-26 6.9-40 6.9-46.5 0-86.8-26.5-106.7-65.2l-5.3 0zM452.7 46.5l-2.1 1.5-53.2 0-2.1-1.5-75.3-54.8 0 129.4c0 57.4 46.6 104 104 104 57.4 0 104-46.6 104-104l0-129.4-75.3 54.8zM384 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;